module.exports = __webpack_public_path__ + "media/application/images/svgs/codesandbox-5cafe694208d889b3b134b7458da1f58.svg";